import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
} from '../../../../services/fetchTools';
import {
  colors,
  btn,
  btnGroup,
  table,
  card,
  page,
  empty,
  spinner,
} from '../../../../style/common/partnerStyle';

var Spinner = require('react-spinkit');

const IconEdit = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);

const IconExternalLink = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
    <polyline points="15 3 21 3 21 9"/>
    <line x1="10" y1="14" x2="21" y2="3"/>
  </svg>
);

const IconDownload = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

const IconTrash = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
    <path d="M10 11v6M14 11v6"/>
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
  </svg>
);

const IconPlus = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19"/>
    <line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);

const IconMapPin = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const IconCalendar = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const IconTrophy = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9H4a2 2 0 0 1-2-2V5h4"/>
    <path d="M18 9h2a2 2 0 0 0 2-2V5h-4"/>
    <path d="M6 5h12v5a6 6 0 0 1-12 0V5z"/>
    <path d="M12 17v4"/>
    <path d="M8 21h8"/>
  </svg>
);

const IconArrowLeft = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12"/>
    <polyline points="12 19 5 12 12 5"/>
  </svg>
);

const IconChevronDown = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

class ViewTournament extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      tournament: {},
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_types: [],
      open: false,
      dialog_open: false,
      competitionView: false,
      viewcomplist: true,
      prev_competition_details: [],
      competitions_id: '',
      addNewCompetitionView: false,
      selected_competition_id: '',
      deleteView: false,
      is_loading: false,
      descExpanded: false,
    };
    this.getCompetitionDetail = this.getCompetitionDetail.bind(this);
  }

  componentDidMount() {
    this.setState({ is_loading: true });
    this.getTournamentList();
    this.getCompetitionDetail();
  }

  getCompetitionDetail() {
    const url = `${getLocationOrigin()}/tournament/get_competition_details/?tournament_id=${this.state.id}`;
    const options = { ...defaultOptions };
    options['method'] = 'get';
    options['headers'] = { 'content-type': 'application/json' };
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data =>
        this.setState({ prev_competition_details: data.competitions_list, is_loading: false })
      )
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  getTournamentList() {
    const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_tournament/`;
    const options = { ...defaultOptions };
    fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => this.setState({ tournament: data.tournament }))
      .catch(error => error);
  }

  onComptitionView(competitions_id) {
    this.setState({ competitions_id, addNewCompetitionView: false });
    this.setState({ competitionView: !this.state.competitionView });
  }

  handleDeleteCompetition(id) {
    this.setState({ selected_competition_id: id, deleteView: !this.state.deleteView });
  }

  deleteCompetition() {
    const url = `${getLocationOrigin()}/tournament/delete_tournament_competition/`;
    const options = { ...defaultOptions };
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ competition_id: this.state.selected_competition_id });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {
        alert(data.message);
        this.handleDeleteCompetition();
        this.getCompetitionDetail();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  render() {
    const {
      tournament,
      prev_competition_details,
      is_loading,
      viewcomplist,
      deleteView,
      descExpanded,
    } = this.state;

    const categorylist =
      prev_competition_details.length > 0
        ? prev_competition_details.filter(x => x.category[1] !== 'Default')
        : [];

    const metaStyle = {
      fontSize: 13,
      color: colors.muted,
      display: 'flex',
      alignItems: 'center',
      gap: 6,
    };

    return (
      <div style={{ ...page.wrap, background: colors.bg, minHeight: '100vh' }}>

        {}
        <div style={{ padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: colors.muted, flexWrap: 'wrap' }}>
          <a href={'/#/partnerTournament'} style={{ color: colors.brand, textDecoration: 'none', fontWeight: 600 }}>Events</a>
          <span style={{ color: '#d1d5db' }}>›</span>
          <a href={'/#/crud/viewTournament/' + tournament.id} style={{ color: colors.brand, textDecoration: 'none', fontWeight: 600 }}>
            {tournament.name}
          </a>
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 24px',
          flexWrap: 'wrap',
          gap: 10,
        }}>
          <Link to={`../../crud/editTournament/${this.state.id}`} style={{ textDecoration: 'none' }}>
            <button style={btn.primary}>
              <IconEdit /> Edit Event
            </button>
          </Link>
          <a
            href={"https://www.sporthood.in/tournament/" + this.state.tournament.id + "/"}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <button style={btn.outline}>
              <IconExternalLink /> Preview
            </button>
          </a>
        </div>

        <div style={{ padding: '24px 20px 40px' }}>

          {}
          <div style={{ ...card.wrap, marginBottom: 20, background: colors.brandLt }}>
            <div style={{ padding: '24px 28px' }}>

              {}
              <div style={{ fontSize: 13, color: colors.muted, marginBottom: 14 }}>
                {tournament.name}
                {tournament.city ? `, ${tournament.city}` : ''}
                {tournament.category ? ` – ${tournament.category}` : ''}
              </div>

              {}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, marginBottom: 20 }}>
                <div style={metaStyle}>
                  <span style={{ fontWeight: 600, color: colors.text }}>Contact No.:</span>
                  <span>{tournament.registration_contact_number || 'null'}</span>
                </div>
                <div style={metaStyle}>
                  <span style={{ fontWeight: 600, color: colors.text }}>Partners:</span>
                  <span>{tournament.partners || 'null'}</span>
                </div>
                <div style={metaStyle}>
                  <span style={{ fontWeight: 600, color: colors.text }}>Organiser:</span>
                  <span>
                    {tournament.organizers && tournament.organizers.length > 0
                      ? tournament.organizers.map(o => o.name).join(', ')
                      : 'null'}
                  </span>
                </div>
              </div>

              {}
              <h1 style={{ fontSize: 32, fontWeight: 800, color: colors.text, margin: '0 0 8px' }}>
                {tournament.name}
              </h1>

              {}
              {tournament.short_description && (
                <p style={{ fontSize: 15, color: colors.muted, margin: '0 0 16px' }}>
                  {tournament.short_description}
                </p>
              )}

              {}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
                {tournament.venue_name && (
                  <div style={{ ...metaStyle, color: colors.text }}>
                    <IconMapPin />
                    <span>Venue: {tournament.venue_name}</span>
                  </div>
                )}
                {tournament.start_date && (
                  <div style={{ ...metaStyle, color: colors.text }}>
                    <IconCalendar />
                    <span>
                      Dates: {moment(tournament.start_date).format('DD MMM')}
                      {tournament.end_date && tournament.end_date !== tournament.start_date
                        ? ` – ${moment(tournament.end_date).format('DD MMM YYYY')}`
                        : ` ${moment(tournament.start_date).format('YYYY')}`}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {}
          {tournament.description && (
            <div style={{ ...card.wrap, marginBottom: 24 }}>
              <div style={{ padding: '24px 28px' }}>
                <h2 style={{ fontSize: 18, fontWeight: 700, color: colors.text, margin: '0 0 16px' }}>
                  About {tournament.name}
                </h2>
                <div
                  style={{
                    fontSize: 14,
                    color: colors.text,
                    lineHeight: 1.7,
                    overflow: descExpanded ? 'visible' : 'hidden',
                    display: descExpanded ? 'block' : '-webkit-box',
                    WebkitLineClamp: descExpanded ? 'unset' : 4,
                    WebkitBoxOrient: 'vertical',
                  }}
                  dangerouslySetInnerHTML={{ __html: tournament.description }}
                />
                {!descExpanded && (
                  <button
                    onClick={() => this.setState({ descExpanded: true })}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: colors.brand,
                      fontWeight: 700,
                      fontSize: 13,
                      cursor: 'pointer',
                      padding: '6px 0 0',
                      fontFamily: 'inherit',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 4,
                    }}
                  >
                    Show more <IconChevronDown />
                  </button>
                )}
              </div>
            </div>
          )}

          {}
          <div style={{ marginBottom: 16 }}>
            <Link
              to={`../../crud/addCompetition/${this.state.id}/${tournament.name}`}
              style={{ textDecoration: 'none' }}
            >
              <button style={btn.primary}>
                <IconPlus /> Add Competition
              </button>
            </Link>
          </div>

          {}
          <div style={card.wrap}>

            {}
            {viewcomplist && (
              <div>
                <div style={card.header}>
                  <h2 style={card.title}>
                    List of Competitions
                    {prev_competition_details.length > 0 && (
                      <span style={card.titleCount}>{prev_competition_details.length} entries</span>
                    )}
                  </h2>
                  <div style={btnGroup}>
                    <a
                      href={`https://api.sporthood.in/report/24311/?tournament_id=${this.state.id}`}
                      style={{ textDecoration: 'none' }}
                    >
                      <button style={btn.outline}>
                        <IconDownload /> Download All
                      </button>
                    </a>
                    <button
                      style={btn.dangerLt}
                      title="Delete Competitions"
                      onClick={() => this.setState({ viewcomplist: false })}
                    >
                      <IconTrash />
                    </button>
                  </div>
                </div>

                {is_loading && (
                  <div style={spinner.wrap}>
                    <Spinner name="line-scale-pulse-out-rapid" color={spinner.color} />
                  </div>
                )}

                {!is_loading && prev_competition_details.length === 0 && (
                  <div style={empty.wrap}>
                    <div style={{ ...empty.icon, color: colors.muted, display: 'flex', justifyContent: 'center' }}>
                      <IconTrophy />
                    </div>
                    <div style={empty.title}>No Competitions Yet</div>
                    <div style={empty.text}>Click "Add Competition" to get started.</div>
                  </div>
                )}

                {prev_competition_details.length > 0 && (
                  <div style={table.wrap}>
                    <table style={table.table}>
                      <thead>
                        <tr>
                          <th style={table.th}>Start Date</th>
                          <th style={table.th}>Reg. End</th>
                          <th style={table.th}>Competition</th>
                          {categorylist.length > 0 && <th style={table.th}>Category</th>}
                          <th style={table.th}>Age Group</th>
                          <th style={table.th}>Venues</th>
                          <th style={table.th}>Registrations</th>
                          <th style={table.th}>View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {prev_competition_details.map((competition, index) => {
                          const gender =
                            competition.gender &&
                            competition.gender.length > 0 &&
                            (competition.gender[1] === 'Boys' || competition.gender[1] === 'Girls')
                              ? `  (${competition.gender[1]})`
                              : '';
                          return (
                            <tr key={index} style={index % 2 === 1 ? table.trAlt : {}}>
                              <td style={table.td}>{competition.start_date[0]}</td>
                              <td style={table.td}>
                                {competition.registration_closed &&
                                  competition.registration_closed.length > 0 &&
                                  moment(competition.registration_closed[1]).format('DD-MM-YYYY hh:mm A')}
                              </td>
                              <td style={table.tdBold}>
                                {competition.game && competition.game.length > 0 && competition.game[1]}
                              </td>
                              {categorylist.length > 0 && (
                                <td style={table.td}>{competition.category[1]}</td>
                              )}
                              <td style={table.td}>
                                {competition.age_groups && competition.age_groups[1] + gender}
                              </td>
                              <td style={table.td}>
                                {competition.venue &&
                                  competition.venue.map((venue, i) => (
                                    <div key={i}>
                                      {venue.length > 0 && venue[1].includes('Live') ? '' : venue[1]}
                                    </div>
                                  ))}
                              </td>
                              <td style={table.td}>
                                <span style={table.badge}>{competition.registration_count}</span>
                              </td>
                              <td style={table.td}>
                                <Link to={`/crud/viewCompetition/${competition.id}/basicInfo`}>
                                  <button style={btn.primarySm}>View</button>
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {!viewcomplist && (
              <div>
                <div style={card.header}>
                  <h2 style={card.title}>Delete Competitions</h2>
                  <button
                    style={btn.outline}
                    onClick={() => this.setState({ viewcomplist: true })}
                  >
                    <IconArrowLeft /> Back
                  </button>
                </div>

                {is_loading && (
                  <div style={spinner.wrap}>
                    <Spinner name="line-scale-pulse-out-rapid" color={spinner.color} />
                  </div>
                )}

                {prev_competition_details.length > 0 && (
                  <div style={table.wrap}>
                    <table style={table.table}>
                      <thead>
                        <tr>
                          <th style={table.th}>Delete</th>
                          <th style={table.th}>Start Date</th>
                          <th style={table.th}>End Date</th>
                          <th style={table.th}>Competition</th>
                          {categorylist.length > 0 && <th style={table.th}>Category</th>}
                          <th style={table.th}>Age Group</th>
                          <th style={table.th}>Venues</th>
                          <th style={table.th}>Registrations</th>
                        </tr>
                      </thead>
                      <tbody>
                        {prev_competition_details.map((competition, index) => (
                          <tr key={index} style={index % 2 === 1 ? table.trAlt : {}}>
                            <td style={table.td}>
                              <button
                                style={btn.dangerLt}
                                onClick={() => this.handleDeleteCompetition(competition.id)}
                              >
                                <IconTrash size={13} />
                              </button>
                            </td>
                            <td style={table.td}>{competition.start_date[0]}</td>
                            <td style={table.td}>{competition.end_date[0]}</td>
                            <td style={table.tdBold}>
                              {competition.game[1] + ' ' + competition.gender[1]}
                            </td>
                            {categorylist.length > 0 && (
                              <td style={table.td}>{competition.category[1]}</td>
                            )}
                            <td style={table.td}>{competition.age_groups[1]}</td>
                            <td style={table.td}>
                              {competition.venue &&
                                competition.venue.map((venue, i) => (
                                  <div key={i}>{venue[1]}</div>
                                ))}
                            </td>
                            <td style={table.td}>
                              <span style={table.badge}>{competition.registration_count}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {deleteView && (
                  <Dialog
                    modal={false}
                    open={true}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                  >
                    <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", padding: '8px 0' }}>
                      <div style={{ fontSize: 16, fontWeight: 700, color: colors.text, marginBottom: 8 }}>
                        Delete Competition
                      </div>
                      <div style={{ fontSize: 13, color: colors.muted }}>
                        Are you sure you want to delete this competition? This action cannot be undone.
                      </div>
                      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 24 }}>
                        <button style={btn.cancel} onClick={() => this.handleDeleteCompetition()}>
                          Cancel
                        </button>
                        <button style={btn.danger} onClick={() => this.deleteCompetition()}>
                          <IconTrash size={13} /> Delete
                        </button>
                      </div>
                    </div>
                  </Dialog>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ViewTournament;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewTournament/index.js